import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Pagination,
} from "@mui/material";
import NoProducts from "../../../Shared/NoProducts/NoProducts";
import "./ExpertsList.scss";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  I18_TRANSLATION_COMMON,
  API_RESPONSE,
  NUMBER_CONSTANTS,
  DIALOG_CONSTANT,
  TOASTER_CONFIGS,
} from "../../../Utilities/Constants/Constants";
import edit from "../../../../Assets/global/edit.svg";
import { checkEmpty } from "../../../Services/Helpers/Helper";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import CreateExpert from "../CreateExpert/CreateExpert";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import HttpsIcon from "@mui/icons-material/Https";
import ReasonDialog from "../../../Shared/ReasonDialog/ReasonDialog";
import { toast } from "react-toastify";
const ExpertsList = () => {
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [expertsList, setExpertsList] = useState([]);
  const [hasProducts, setHasProducts] = useState(API_RESPONSE.TRUE);
  const [dialogOpenStatus, setDialogOpenStatus] = useState(false);
  const [blockId, setBlockId] = useState<any>("")

  const [page, setPage] = useState(1);
  const [totalPage, setTotalCount] = useState(0);
  const [rowPerPage, setRowPerPage] = useState(10);
  const [reasonModal, setReasonModal] = useState(false);
  const dialogTitle = DIALOG_CONSTANT.BLOCK;

  const navigate = useNavigate();

  useEffect(() => {
    getExpertsList();
  }, [page, rowPerPage]);

useEffect(() => {
  const pathName = window.location?.pathname;
  const payload = {
    record_area: pathName.slice(1)
  }
  axiosInstance.post(`${API_END_POINTS?.RECORD_AREA}`, payload).then((response: any) => {
  }).catch(() => {
  })
}, [])

  const onRowChange = (event: any) => {
    setPage(NUMBER_CONSTANTS.ONE);
    setRowPerPage(parseInt(event.target.value));
  };

  const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
    setPage(newPage);
  };

  const getExpertsList = () => {
    axiosInstance.get(API_END_POINTS.EXPERTS_LIST +
      "?page=" +
      page +
      "&limit=" +
      rowPerPage).then((response: any) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          setExpertsList(response.data.result.data);
          setTotalCount(response.data.result.total_page);
          setHasProducts(checkEmpty(response.data.result.data));
        }
      });
  };

  const onCloseDialog = () => {
    setDialogOpenStatus(false);
    getExpertsList();
  };
  const onCloseReason = () => {
    setReasonModal(false)
  }

  const onSubmitReason = (value: any) => {
    const payload = {
      id: blockId,
      block_type: "expert",
      reason: value?.reason,
    }

    axiosInstance.put(API_END_POINTS.BLOCK_USER_LIST, null, { params: payload }).then((respones: any) => {
      if (respones?.status) {
        toast.success(respones.data.message, TOASTER_CONFIGS);
        setReasonModal(false)
        getExpertsList()

      }
    }).catch(() => {

    })
  }
  const handleUnblock = (id: any) => {
    const payload = {
      id: id,
      block_type: "expert",
      reason:""
    }
    if (id) {
      axiosInstance.put(API_END_POINTS.BLOCK_USER_LIST, null, { params: payload }).then((respones: any) => {
        if (respones?.status) {
          toast.success(respones.data.message, TOASTER_CONFIGS);
          getExpertsList()
        }

      }).catch(() => {

      })
    }

  }
  let res = "Test"
  return (
    <div className="experts-list-wrapper">
      <CreateExpert
        modalState={dialogOpenStatus}
        dialogStatus={onCloseDialog}
      />
      <div className="table-wrapper">
        <div className="submit-btn-wrapper">
          <button
            type="submit"
            className="btn btn-secondary"
            onClick={() => {
              setDialogOpenStatus(true);
            }}
          >
            Add Educational Expert
          </button>
        </div>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t("S.NO")}</TableCell>
                <TableCell>{t("First Name")}</TableCell>
                <TableCell>{t("Last Name")}</TableCell>
                <TableCell>{t("Email")}</TableCell>
                <TableCell>{t("Phone Number")}</TableCell>
                <TableCell>{t("Actions")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {expertsList.map((expertData: any, index: any) => {
                return (
                  <>
                    <TableRow key={index + 1}>
                      <TableCell>{page - 1 === 0
                        ? index + 1
                        : (page - 1) * rowPerPage + (index + 1)}</TableCell>
                      <TableCell>{expertData.firstname}</TableCell>
                      <TableCell>{expertData.lastname}</TableCell>
                      <TableCell>{expertData.email}</TableCell>
                      <TableCell>{expertData.phone_number}</TableCell>
                      <TableCell>
                        <div className="action_wrap">
                          {expertData?.is_block ? (
                            <div
                              className="reject_btn_wrapper"
                              onClick={() => handleUnblock(expertData?.id)}
                            >
                              <div className="accept_btn_label">
                                {t("Unblock")}
                              </div>
                              <div className="lock_icon_wrapper">
                                <HttpsIcon className="lock_icon" />
                              </div>
                            </div>) :
                            <div
                              className="accept_btn_wrapper"
                              onClick={() => {
                                setReasonModal(true)
                                setBlockId(expertData?.id)
                              }}
                            >
                              <div className="unlock_icon_wrapper">
                                <LockOpenTwoToneIcon className="unlock_icon" />
                              </div>
                              <div className="accept_btn_label">
                                {t("Block")}
                              </div>
                            </div>
                          }
                        </div>

                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
          {!hasProducts && <NoProducts />}
        </TableContainer>
        {hasProducts && (
          <div className="tablePagination">
            <div className="row">
              <div className="col-md-7">
                <div className="pagination-wrap">
                  <Pagination
                    count={totalPage}
                    page={page}
                    onChange={handleChangePage}
                  />
                </div>
              </div>
              <div className="col-md-5">
                <div className="rows-per-page">
                  <p>{t("Rows per page")}:</p>
                  <select
                    className="rows-select"
                    value={rowPerPage}
                    onChange={onRowChange}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ReasonDialog
        modalState={reasonModal}
        dialogStatus={onCloseReason}
        submitReason={onSubmitReason}
        title={dialogTitle}
      />
    </div>
  );
};

export default ExpertsList;
